import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SynchronizeInventoryMovementService {

  constructor(private _httpClient: HttpClient) { }

  synchronizeAsync(): Observable<PreInvoicingAlertModel[]> {
    return this._httpClient.post<PreInvoicingAlertModel[]>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.synchronizeSiesaCloud.SynchronizeAsync}`,
      null
    );
  }
}
